import classNames from 'classnames/bind';
import styles from './Notice.module.css';

import { useGetNoticeQuery } from '../../../services/settings';
import TableBody from '../../../components/TableBody';
import { NOTICE } from '../../../constants';

export default function Notice() {
  const cx = classNames.bind(styles);
  const { data: noticeList, isLoading } = useGetNoticeQuery({ page: 0 });

  if (isLoading || !noticeList) return null;

  return (
    <>
      <h2>{NOTICE}</h2>
      <TableBody name="notice" list={noticeList} />
    </>
  );
}
